/* eslint @typescript-eslint/strict-boolean-expressions: off */

import cn from "classnames";
import React from "react";
import styles from "gui/grid/grid.module.css";
import { AnimateRevealDown } from "gui/animate/animate";
import { AnimateRevealUpScroll } from "gui/animate/animate";

interface GridProps {
  as?: string;
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  gaps?: boolean;
  revealOnLoad?: boolean;
  revealOnScroll?: boolean;
  "aria-labelledby"?: string;
}

export const Grid: React.FC<GridProps> = (props) => {
  const as = props.as ?? "section";

  const componentProps = {
    className: cn(styles.grid, props.gaps && styles.gaps, props.className),
    id: props.id,
    style: props.style,
    "aria-labelledby": props["aria-labelledby"],
  };

  const component = React.createElement(as, componentProps, props.children);

  if (props.revealOnLoad) {
    return <AnimateRevealDown>{component}</AnimateRevealDown>;
  }

  if (props.revealOnScroll) {
    return <AnimateRevealUpScroll>{component}</AnimateRevealUpScroll>;
  }

  return component;
};
